import React, { useEffect, useMemo } from 'react';
import { useState, useCallback } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import { Link, ColorPicker } from './Toolbar';
import { RichTextEditorWrap } from './RichTextEditor.stc';

function RichTextEditor({ name, value = '', onChange, modContent = {} }) {
    const { type = 'extended' } = modContent;
    const [editorState, setEditorState] = useState(() =>
        EditorState.createEmpty()
    );

    const toolbar = useMemo(
        () => ({
            options: {
                simple: ['inline', 'link', 'remove'],
                extended: ['inline', 'list', 'link', 'remove'],
            }[type],
            inline: {
                inDropdown: false,
                options: {
                    simple: ['bold', 'italic', 'underline', 'strikethrough'],
                    extended: [
                        'bold',
                        'italic',
                        'underline',
                        'strikethrough',
                        'monospace',
                        'superscript',
                        'subscript',
                    ],
                }[type],
            },
            colorPicker: { component: ColorPicker },
            link: {
                inDropdown: false,
                className: 'rdw-link-wrapper',
                component: Link,
                showOpenOptionOnHover: false,
                defaultTargetOption: '_self',
                options: ['link', 'unlink'],
            },
            list: {
                inDropdown: false,
                options: ['unordered', 'ordered'],
            },
        }),
        [type]
    );

    const onEditorStateChange = useCallback(
        (editorState) => {
            const rawData = convertToRaw(editorState.getCurrentContent());
            const html = draftToHtml(rawData);
            onChange({ name, value: html });

            setEditorState(editorState);
        },
        [name, onChange]
    );

    useEffect(() => {
        const blocksFromHtml = htmlToDraft(value);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(
            contentBlocks,
            entityMap
        );
        const editorState = EditorState.createWithContent(contentState);
        setEditorState(editorState);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // mounted

    return (
        <RichTextEditorWrap size={modContent?.height}>
            <Editor
                stripPastedStyles
                toolbar={toolbar}
                editorState={editorState}
                onEditorStateChange={onEditorStateChange}
            />
            <p>* Shift + Enter to insert a new line</p>
        </RichTextEditorWrap>
    );
}

export default RichTextEditor;
